import { useContext } from 'react';

import ConfigContext from './config.context';
import type { ContextValue } from './type';

export function useConfig(): ContextValue {
  return useContext(ConfigContext);
}
